const messages = {
  pt: {
    translations: {
      newTicketOficial: {
        createAndSend: "Criar e Enviar Template",
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Login",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      templateManager: {
        title: "Gerenciamento de Templates",
        connection: "Conexão",
        search: "Buscar...",
        syncTooltip: "Sincronizar com a Meta",
        sync: "Sync",
        createTemplate: "Criar Template",
        noConnection: "Nenhuma conexão de API Oficial encontrada. Adicione uma conexão oficial para gerenciar templates.",
        noTemplates: 'Nenhum template encontrado. Clique em "Sync" para sincronizar ou em "Criar Template" para criar um novo.',
        table: { name: "Nome", category: "Categoria", language: "Idioma", status: "Status", actions: "Ações" },
        tooltips: { view: "Ver detalhes", edit: "Editar (recriar template)", delete: "Excluir template" },
        categories: { marketing: "Marketing", utility: "Utilidade", authentication: "Autenticação" },
        deleteModal: {
          title: "Excluir template",
          body: "Esta ação excluirá o template na Meta e localmente. Deseja continuar?",
        },
        viewModal: {
          close: "Fechar",
          title: "Detalhes do Template",
          name: "Nome",
          language: "Idioma",
          status: "Status",
          category: "Categoria",
          components: "Componentes",
        },
        createModal: {
          title: "Criar Novo Template",
          templateName: "Nome do Template",
          templateNameHelper: "Somente letras minúsculas, números e _",
          category: "Categoria",
          language: "Idioma",
          header: "Cabeçalho (opcional)",
          headerHelper: "Texto exibido na parte superior do template",
          body: "Corpo da Mensagem",
          bodyHelper: "Use {1}, {2}, etc. para variáveis. Ex: Olá {1}, seu pedido {2} está pronto!",
          footer: "Rodapé (opcional)",
          footerHelper: "Texto pequeno no final do template",
          buttonsTitle: "Botões (opcional - máx 3)",
          quickReply: "+ Resposta Rápida",
          urlButton: "+ Link",
          phoneButton: "+ Telefone",
          chipQuickReply: "Resp. Rápida",
          chipUrl: "Link",
          chipPhone: "Telefone",
          textLabel: "Texto",
          urlLabel: "URL",
          phoneLabel: "Telefone",
          preview: "Pré-visualização",
          buttonPlaceholder: "Botão {{index}}",
          previewEmpty: "Comece a digitar o corpo para ver a pré-visualização aqui",
          examplesTitle: "Exemplos de variáveis (exigido pela Meta)",
          examplesSubtitle: "A Meta exige um valor de exemplo para cada variável para que os revisores saibam qual conteúdo irá ali.",
          exampleFor: "exemplo para",
          cancel: "Cancelar",
          submit: "Enviar para Aprovação",
          submitting: "Enviando...",
        },
        validation: {
          nameAndBodyRequired: "O nome do template e o corpo da mensagem são obrigatórios",
          examplesRequired: "Você deve informar um exemplo para:",
        },
        toast: {
          approved: 'O template "{{name}}" foi APROVADO pela Meta! 🎉',
          rejected: 'O template "{{name}}" foi REJEITADO pela Meta',
          statusChange: 'Template "{{name}}": {{old}} → {{new}}',
          syncDone: "Sincronização concluída - {{count}} template(s) com mudança de status",
          syncNoChanges: "Templates sincronizados - sem mudanças de status",
          tokenExpired: "⚠️ Token da API Oficial expirado ou inválido! Atualize o token de acesso da Meta nas configurações da conexão.",
          submitted: "Template enviado para aprovação da Meta",
          deleted: "Template excluído com sucesso",
        },
        status: {
          approved: "Aprovado",
          rejected: "Rejeitado",
          pending: "Pendente",
          paused: "Pausado",
        },
      },
      flowBuilder: {
        title: "Editor de Fluxos",
        addNodes: "Adicionar Nós",
        saveFlow: "Salvar Fluxo",
        startOfFlow: "Inicio do fluxo",
        intervalLabel: "Intervalo {{sec}} seg.",
        toast: {
          saved: "Fluxo salvo com sucesso",
          saveError: "Erro ao salvar o fluxo",
        },
        categories: {
          basic: "Básicos",
          content: "Conteúdo",
          interaction: "Interação",
          logic: "Lógica",
          system: "Sistema",
          integrations: "Integrações",
        },
        nodes: {
          start: { name: "Início", description: "Ponto inicial do fluxo" },
          content: { name: "Conteúdo", description: "Enviar texto, imagem, áudio ou vídeo" },
          text: { name: "Texto", description: "Mensagem de texto simples" },
          menu: { name: "Menu", description: "Menu numérico de opções" },
          interactiveMenu: { name: "Msg Interativa API", description: "Botões e listas (Baileys)" },
          input: { name: "Input", description: "Coletar entrada do usuário" },
          interval: { name: "Intervalo", description: "Pausar execução por tempo" },
          random: { name: "Randomizador", description: "Escolha aleatória de caminhos" },
          conditionCompare: { name: "Se/Senão (If/Else)", description: "Bifurcar fluxo com base em condição" },
          ticket: { name: "Filas", description: "Gerenciar filas de atendimento" },
          tag: { name: "Tags", description: "Adicionar tags ao contato" },
          removeTag: { name: "Remover Tag", description: "Remover tags do contato" },
          switchFlow: { name: "Trocar Flow", description: "Direcionar para outro fluxo" },
          attendant: { name: "Atendente", description: "Transferir para atendente" },
          httpRequest: { name: "HTTP Request", description: "Requisição HTTP externa" },
          variable: { name: "Variável", description: "Definir variáveis globais" },
          gemini: { name: "Gemini", description: "Integração com Gemini" },
          openai: { name: "OpenAI", description: "Integração com OpenAI" },
          claude: { name: "Claude", description: "Integração com Claude (Anthropic)" },
        },
        aiModal: {
          addTitle: "Adicionar {{provider}} ao fluxo",
          editTitle: "Editar {{provider}} do fluxo",
          buttons: { add: "Adicionar", save: "Salvar", cancel: "Cancelar" },
          basicSettings: "Configurações Básicas - {{provider}}",
          assistantName: "Nome do Assistente",
          apiKey: "API Key {{provider}}",
          model: "Modelo {{provider}}",
          systemPrompt: "Prompt do Sistema",
          systemPromptPlaceholder: "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder...",
          sendWelcomeMessage: "Enviar saudação automática ao ativar",
          sendWelcomeMessageHelper: "Enviada assim que este nó é ativado (\"Olá! Sou [nome do assistente]...\"). Desative se seu fluxo já envia sua própria saudação antes de chegar aqui.",
          temperature: "Temperatura",
          temperatureHelper: "0 = conservador, 2 = criativo",
          maxTokens: "Max Tokens",
          maxTokensHelper: "Tamanho máximo da resposta",
          maxMessages: "Max Mensagens",
          maxMessagesHelper: "Histórico de contexto",
          voiceSettings: "Configurações de Voz (Opcional)",
          responseType: "Tipo de Resposta",
          textOnly: "Apenas Texto",
          voiceKeyAzure: "Voice Key (Azure)",
          voiceKeyPlaceholder: "Chave do Azure Speech Service",
          voiceRegionAzure: "Voice Region (Azure)",
          voiceRegionPlaceholder: "ex: brazilsouth",
          flowBehavior: "Comportamento do Fluxo",
          flowBehaviorTooltip: "Configure como o {{provider}} deve se comportar no fluxo",
          operatingMode: "Modo de Funcionamento",
          permanentLabel: "Permanente",
          permanentDesc1: "- Encerrar fluxo aqui",
          permanentDesc2: "O usuário fica conversando com a IA até pedir transferência ou encerrar",
          temporaryLabel: "Temporário",
          temporaryDesc1: "- Volta ao fluxo depois",
          temporaryDesc2: "A IA executa uma tarefa específica e depois retorna ao fluxo normal",
          temporarySettingsTitle: "⏱️ Configurações do Modo Temporário",
          temporarySettingsSubtitle: "Configure quando a IA deve parar e retornar ao fluxo",
          maxInteractions: "Máximo de Interações",
          maxInteractionsHelper: "Número máximo de mensagens antes de voltar ao fluxo (0 = ilimitado)",
          timeoutMinutes: "Timeout (minutos)",
          timeoutHelper: "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
          continueKeywordsTitle: "Palavras-chave para Continuar Fluxo",
          continueKeywordsPlaceholder: "Digite uma palavra-chave",
          addKeywordButton: "Adicionar",
          continueKeywordsHelper: "Quando o usuário enviar uma dessas palavras, o fluxo continuará automaticamente",
          objective: "Objetivo da IA",
          objectiveHelper: "Descreva o que a IA deve completar (ex: 'Coletar nome, email e telefone')",
          objectivePlaceholder: "Ex: Coletar dados do cliente, Qualificar interesse, Diagnosticar problema...",
          autoComplete: "Auto completar quando atingir objetivo",
          autoCompleteHelper: "A IA analisará automaticamente se completou o objetivo e voltará ao fluxo",
          transferQueueId: "ID da Fila (para transferência)",
          transferQueueHelper: "ID da fila para onde transferir se usuário pedir atendente (0 = não transferir)",
          validation: {
            tooShort: "Muito curto!",
            tooLong: "Muito longo!",
            required: "Obrigatório",
            promptRequired: "Descreva o treinamento para Inteligência Artificial",
            invalidModel: "Modelo inválido",
            modelRequired: "Informe o modelo",
            minTokens: "Mínimo 10 tokens",
            maxTokensLimit: "Máximo {{max}} tokens",
            tokensRequired: "Informe o número máximo de tokens",
            minTemp: "Mínimo 0",
            maxTemp: "Máximo 2",
            temperatureRequired: "Informe a temperatura",
            apiKeyRequired: "Informe a API Key",
            minMessages: "Mínimo 1 mensagem",
            maxMessagesLimit: "Máximo 100 mensagens",
            messagesRequired: "Informe o número máximo de mensagens",
            voiceRequired: "Informe o modo para Voz",
            voiceKeyRequired: "Voice Key é obrigatória para síntese de voz",
            voiceRegionRequired: "Voice Region é obrigatória para síntese de voz",
            invalidFlowMode: "Modo de fluxo inválido",
            flowModeRequired: "Selecione o modo de fluxo",
            minInteractions: "Mínimo 1 interação",
            maxInteractionsLimit: "Máximo 50 interações",
            minTimeout: "Mínimo 1 minuto",
            maxTimeoutLimit: "Máximo 60 minutos",
            keywordEmpty: "Palavra-chave não pode estar vazia",
            keywordsRequired: "Pelo menos uma palavra-chave é obrigatória no modo temporário",
            objectiveRequired: "Objetivo é obrigatório quando auto completar está ativo",
          },
        },
        nodeLabels: {
          startDescription: "Este bloco marca o inicio do seu fluxo!",
          message: "Mensagem",
          image: "Imagem",
          audio: "Audio",
          video: "Video",
          recordedNow: "Gravado na hora",
          audioSent: "Audio enviado",
          noHtml5Support: "seu navegador não suporta HTML5",
          seconds: "{{sec}} segundos",
          secondsWord: "segundos",
          numericMenu: "Menu Numérico",
          tag: "Tag",
          tagNotSelected: "Tag não selecionada",
          removeTagDescription: "Remove a tag do contato",
          switchFlow: "Trocar Fluxo",
          queue: "Fila",
          globalVariable: "Variável Global",
          variableNameLabel: "Nome da variável",
          valueLabel: "Valor",
          variableValueHelper: "Você pode usar valores estáticos ou referências como ${outraVariavel}",
          saved: "Salvo!",
          saveVariableButton: "Salvar variável",
          variableSavedSuccess: "Variável salva com sucesso!",
          ifElse: "Se / Senão",
          and: "E",
          or: "OU",
          true: "Verdadeiro",
          false: "Falso",
          field: "campo",
          value: "valor",
          question: "Pergunta:",
          questionNotDefined: "Pergunta não definida",
          variableToStoreAnswer: "Variável para armazenar resposta:",
          variableNotDefined: "Variável não definida",
          valueTooltip: "Valor: {{value}}",
          usingVariables: "Usando variáveis: {{vars}}",
          alwaysAsk: "Sempre perguntar (mesmo se variável já existir)",
          buttons: "Botões",
          bodyPlaceholder: "Corpo da mensagem...",
          buttonDefault: "Botão {{number}}",
          selectDefault: "Selecionar",
          itemDefault: "Item {{number}}",
          operators: {
            equals: "==",
            notEquals: "≠",
            contains: "∈ contém",
            notContains: "∉ não contém",
            containsAny: "∈… contém algum",
            greaterThan: ">",
            lessThan: "<",
            greaterOrEqual: "≥",
            lessOrEqual: "≤",
            startsWith: "⊰ inicia com",
            endsWith: "⊱ termina com",
            isEmpty: "∅ vazio",
            isNotEmpty: "¬∅ não vazio",
            regex: ".* regex",
          },
        },
        httpRequest: {
          title: "Requisição HTTP",
          presetsTitle: "Webhooks Pré-configurados",
          selectPreset: "Selecionar preset",
          selectPresetPlaceholder: "Escolha uma configuração pronta...",
          systemChip: "SISTEMA",
          usingPreset: "Usando preset: ",
          removeButton: "Remover",
          url: "URL",
          urlFromPreset: "URL (do preset)",
          urlHelperPreset: "Você pode editar a URL base do preset se necessário",
          method: "Método",
          testRequest: "Testar Requisição",
          apiResponse: "Resposta da API:",
          viewFullResponse: "Ver resposta completa",
          showAdvanced: "Mostrar avançado",
          hideAdvanced: "Ocultar avançado",
          advancedOverridePresetWarning: "Configurações avançadas podem sobrescrever as configurações do preset",
          timeoutMs: "Timeout (ms)",
          queryParams: "Parâmetros de Query",
          key: "Chave",
          value: "Valor",
          addParam: "Adicionar Parâmetro",
          headersJson: "Cabeçalhos (JSON)",
          requestBodyJson: "Corpo da requisição (JSON)",
          editRequestBody: "Editar corpo da requisição",
          close: "Fechar",
          hideMapping: "Ocultar Variáveis da Resposta",
          mapResponseVariables: "Mapear Variáveis da Resposta",
          mapResponseVariablesTitle: "Mapear dados da resposta para variáveis",
          path: "Caminho",
          pathPlaceholder: "ex: data.user.id",
          variableName: "Nome da variável",
          variableNamePlaceholder: "ex: userId",
          addVariable: "Adicionar variável",
          usefulTips: "Dicas úteis:",
          apiResponseAutoSaved: "A resposta completa da API é salva automaticamente na variável global",
          variableUsageTip: "Você pode usar ${nomeDaVariavel} no URL e corpo da requisição para incluir valores de variáveis.",
          fullResponseTitle: "Resposta completa da API",
          configSaved: "Configuração salva!",
          requestError: "Erro na requisição",
        },
        modals: {
          text: {
            addTitle: "Adicionar mensagem ao fluxo",
            editTitle: "Editar mensagem ao fluxo",
            add: "Adicionar",
            save: "Salvar",
            messageLabel: "Mensagem",
          },
          interval: {
            addTitle: "Adicionar um intervalo ao fluxo",
            editTitle: "Editar intervalo",
            add: "Adicionar",
            edit: "Editar",
            secondsLabel: "Tempo em segundos",
            toastMissingValue: "Adicione o valor de intervalo",
            toastMaxTime: "Máximo de tempo atingido 120 segundos",
          },
          image: {
            addTitle: "Adicionar imagem ao fluxo",
            editTitle: "Editar imagem",
            add: "Adicionar",
            save: "Salvar",
            captionLabel: "Legenda (opcional)",
            uploadButton: "Enviar imagem",
            toastAdded: "Imagem adicionada com sucesso!",
            toastFileTooBig: "Arquivo é muito grande! 2MB máximo",
          },
          audio: {
            addTitle: "Adicionar audio ao fluxo",
            editTitle: "Editar audio",
            add: "Adicionar",
            save: "Salvar",
            captionLabel: "Legenda (opcional)",
            uploadButton: "Enviar audio",
            sendAsRecorded: "Enviar como audio gravado na hora",
            toastAdded: "Audio adicionada com sucesso!",
            toastFileTooBig: "Arquivo é muito grande! 5MB máximo",
          },
          video: {
            addTitle: "Adicionar video ao fluxo",
            editTitle: "Editar video",
            add: "Adicionar",
            save: "Salvar",
            captionLabel: "Legenda (opcional)",
            uploadButton: "Enviar video",
            mp4OnlyWarning: "ATENÇÃO! Apenas videos em MP4!",
            toastAdded: "Video adicionado com sucesso!",
            toastFileTooBig: "Arquivo é muito grande! 20MB máximo",
          },
          tag: {
            addTitle: "Adicionar uma tag ao fluxo",
            editTitle: "Editar tag",
            add: "Adicionar",
            edit: "Editar",
            chooseTag: "Escolha uma tag",
            selectTag: "Selecione uma tag",
            noTagSelected: "Nenhuma tag selecionada",
            toastMissing: "Adicione uma tag",
          },
          removeTag: {
            addTitle: "Remover uma tag do fluxo",
            editTitle: "Editar remoção de tag",
            add: "Adicionar Remoção",
            edit: "Editar",
            chooseTagToRemove: "Escolha uma tag para remover do contato",
            description: "Esta ação removerá a tag selecionada do contato quando o fluxo for executado",
            selectTagToRemove: "Selecione uma tag para remover",
            noTagSelected: "Nenhuma tag selecionada",
            toastMissing: "Selecione uma tag para remover",
          },
          switchFlow: {
            addTitle: "Adicionar Troca de Fluxo",
            editTitle: "Editar Troca de Fluxo",
            add: "Adicionar",
            edit: "Editar",
            chooseFlowPlaceholder: "Escolha um fluxo",
          },
          attendant: {
            addTitle: "Adicionar um atendente ao fluxo",
            editTitle: "Editar atendente",
            add: "Adicionar",
            edit: "Editar",
            chooseAgent: "Escolha um atendente",
            selectUser: "Selecione um usuário",
            toastMissing: "Adicione um atendente",
          },
          ticket: {
            addTitle: "Adicionar uma fila ao fluxo",
            editTitle: "Editar fila",
            add: "Adicionar",
            edit: "Editar",
            chooseQueue: "Escolha a fila que deseja transferir",
            selectConnection: "Selecione uma Conexão",
            toastMissing: "Adicione uma fila",
          },
          menu: {
            addTitle: "Adicionar menu ao fluxo",
            editTitle: "Editar menu",
            add: "Adicionar",
            save: "Salvar",
            explanationLabel: "Mensagem de explicação do menu",
            addOption: "Adicionar Opção",
            typeOption: "Digite {{number}}",
            optionPlaceholder: "Digite opção",
          },
          randomizer: {
            addTitle: "Adicionar um randomizador ao fluxo",
            editTitle: "Editar randomizador",
            add: "Adicionar",
            edit: "Editar",
            toastMissingValue: "Adicione o valor de intervalo",
            toastMaxTime: "Máximo de tempo atingido 120 segundos",
          },
          input: {
            addTitle: "Adicionar input ao fluxo",
            editTitle: "Editar input do fluxo",
            add: "Adicionar",
            saveChanges: "Salvar alterações",
            questionLabel: "Pergunta",
            questionTooltip: "A pergunta que será enviada ao usuário. Você pode incluir variáveis usando ${nomeVariavel}",
            questionInputLabel: "Digite a pergunta",
            questionPlaceholder: "Ex: Olá {{firstName}}, qual é a sua idade?",
            flowVariablesLabel: "Variáveis de fluxo (clique para inserir):",
            variableNameLabel: "Nome da variável",
            variableNameTooltip: "Nome da variável onde a resposta será armazenada. Não use espaços ou caracteres especiais.",
            variableNamePlaceholder: "Ex: idade_cliente",
            variableNameHelper: "A resposta do usuário será armazenada nesta variável",
            howItWorksTitle: "Como funciona",
            howItWorksDescription: "Este nó enviará a pergunta ao usuário e aguardará uma resposta. Quando o usuário responder, o valor será armazenado na variável especificada e o fluxo continuará para o próximo nó.",
          },
          flowModal: {
            validation: {
              tooShort: "Muito curto!",
              tooLong: "Muito longo!",
              nameRequired: "Digite um nome!",
            },
          },
          interactive: {
            addTitle: "Mensagem Interativa (Baileys)",
            editTitle: "Editar Mensagem Interativa",
            add: "Adicionar",
            save: "Salvar",
            cancel: "Cancelar",
            bodyRequired: "O corpo da mensagem é obrigatório!",
            addAtLeastOneOption: "Adicione pelo menos uma opção!",
            imageUploadError: "Erro ao enviar imagem",
            fileTooBig: "Arquivo muito grande! Máximo 2MB",
            maxOptionsWarning: "Limite máximo de {{max}} opções para botões!",
            preview: "Pré-visualização",
            messageType: "Tipo de mensagem interativa",
            buttonsMax3: "Botões (máx. 3)",
            infoBanner: "Botões interativos via Baileys (nativeFlowMessage). Funciona em conexões não-oficiais. Limite de 3 botões.",
            contentTab: "CONTEÚDO DA MENSAGEM",
            buttonsTab: "BOTÕES ({{count}}/{{max}})",
            bodyLabel: "Corpo da mensagem",
            footerLabel: "Rodapé (opcional)",
            headerImageLabel: "Imagem de cabeçalho (opcional)",
            changeImage: "Trocar imagem",
            uploadImage: "Enviar imagem",
            listButtonTextLabel: "Texto do botão da lista",
            listButtonTextHelper: "Texto exibido no botão que abre a lista",
            optionsButtons: "Botões",
            optionsList: "Opções da lista",
            addButton: "Adicionar",
            addAtLeastOneOptionWarning: "⚠ Adicione pelo menos uma opção.",
            buttonTextPlaceholder: "Texto do botão {{number}}",
            optionPlaceholder: "Opção {{number}}",
          },
          conditionCompare: {
            operators: {
              equals: "Igual a",
              notEquals: "Diferente de",
              contains: "Contém texto",
              notContains: "Não contém",
              containsAny: "Contém qualquer (,)",
              startsWith: "Começa com",
              endsWith: "Termina com",
              greaterThan: "Maior que",
              lessThan: "Menor que",
              greaterOrEqual: "Maior ou igual a",
              lessOrEqual: "Menor ou igual a",
              isEmpty: "Está vazio",
              isNotEmpty: "Não está vazio",
              regex: "Expressão regular",
            },
            operatorGroups: {
              Igualdade: "Igualdade",
              Texto: "Texto",
              "Numérico": "Numérico",
              Estado: "Estado",
              "Avançado": "Avançado",
            },
            categories: {
              "Contato": "Contato",
              "Ticket": "Ticket",
              "Variável Global": "Variável Global",
              "Input Capturado": "Input Capturado",
              "Menu": "Menu",
              "HTTP / API": "HTTP / API",
              "API": "API",
            },
            staticVars: {
              contactName: "Nome do contato",
              contactEmail: "Email do contato",
              contactPhone: "Telefone / número do contato",
              lastMessage: "Última mensagem recebida",
              ticketId: "ID do ticket atual",
              ticketStatus: "Status do ticket (open/pending/closed)",
              ticketQueue: "Fila atual do ticket",
              apiResponse: "Resposta da última requisição HTTP",
            },
            dynamicVarDesc: {
              globalVariableValue: 'Valor: "{{value}}"',
              globalVariableGeneric: "Variável global do fluxo",
              inputAnswerFrom: 'Resposta de: "{{label}}"',
              inputAnswerGeneric: "Resposta capturada do usuário",
              menuResponse: 'Resposta do menu: "{{message}}"',
              menuOption: 'Opção [{{number}}] do menu: "{{value}}"',
              httpMappedFrom: "Mapeado de: {{path}}",
              httpResponseVar: "Variável da resposta HTTP",
            },
            titleEdit: "Editar Condição",
            titleNew: "Nova Condição",
            fieldLabel: "Variável / Campo",
            fieldPlaceholder: "Digite $ para ver variáveis disponíveis",
            fieldHelper: "Digite $ para autocompletar variáveis do fluxo",
            insertVariableTooltip: "Inserir variável pelo seletor",
            conditionTypeLabel: "Tipo de condição",
            comparisonValueLabel: "Valor da comparação",
            commaValuesLabel: "Valores separados por vírgula",
            commaPlaceholder: "sim, s, yes, 1",
            regexHelper: "Ex: ^[0-9]{11}$ — expressão regular JavaScript",
            containsAnyHelper: "Qualquer token da lista dispara Verdadeiro",
            valueHelper: "Valor fixo ou variável com $",
            and: "E (AND)",
            or: "OU (OR)",
            addCondition: "Adicionar condição",
            logicAllTrue: "TODAS as condições",
            logicAnyTrue: "QUALQUER condição",
            logicPrefix: "Lógica: Verdadeiro se",
            logicSuffix: "forem satisfeitas",
            quickTipsTitle: "💡 Dicas rápidas",
            tip1: "Contém qualquer (,): separe tokens por vírgula → sim, s, yes, 1",
            tip2: "Regex: use expressão JS → ^[0-9]{11}$ para validar CPF",
            tip3: "Use ${variavel} em qualquer campo para referenciar valores dinâmicos",
            saveError: "Ocorreu um erro ao salvar. Tente novamente.",
            conditionFieldRequired: 'Condição {{number}}: o campo "Variável / Campo" é obrigatório',
            conditionValueRequired: 'Condição {{number}}: o campo "Valor da comparação" é obrigatório',
            cancel: "Cancelar",
            saving: "Salvando...",
            saveChanges: "Salvar alterações",
            add: "Adicionar",
            selectVariable: "Selecionar variável",
            varsFoundInFlow: "{{count}} variável(is) encontrada(s) no fluxo",
            addVarNodesHint: "Adicione nós de Variável Global ou Input para variáveis dinâmicas",
            searchVariablePlaceholder: "Buscar variável...",
            noVariableFound: "Nenhuma variável encontrada",
            flowVariablesTitle: "Variáveis do fluxo",
          },
          singleBlock: {
            addTitle: "Adicionar conteúdo ao fluxo",
            editTitle: "Editar conteúdo",
            add: "Adicionar",
            save: "Salvar",
            toastEmptyMessage: "Campos de mensagem vazio!",
            toastIntervalRange: "Intervalo não pode ser 0 ou maior que 120!",
            toastImageTooBig: "Arquivo é muito grande! 2MB máximo",
            toastAudioTooBig: "Arquivo é muito grande! 5MB máximo",
            toastVideoTooBig: "Arquivo é muito grande! 20MB máximo",
            toastDocumentTooBig: "Arquivo é muito grande! 10MB máximo",
            toastContentAdded: "Conteúdo adicionada com sucesso!",
            toastDeleteEmptyCards: "Delete os cards vazios(Imagem, Audio e Video)",
            documentLabel: "Documento",
            uploadDocument: "Enviar Documento",
            viewDocument: "Visualizar Documento",
            availableVariables: "Variáveis disponíveis",
            uploadingContent: "Subindo os arquivos e criando o conteúdo...",
            variableLabels: {
              firstName: "Primeiro Nome",
              name: "Nome",
              userName: "Atendente",
              ms: "Saudação",
              protocol: "Protocolo",
              date: "Data",
              hour: "Hora",
              ticket_id: "Nº do Chamado",
              queue: "Setor",
              connection: "Conexão",
              phoneNumber: "Telefone",
              email: "E-mail",
              kanban: "Kanban",
            },
          },
        },
      },
      flowBuilderList: {
        title: "Fluxos de Conversa ({{count}})",
        searchPlaceholder: "Buscar fluxos...",
        importButton: "Importar (.zip)",
        newFlowButton: "Novo Fluxo",
        emptyTitleSearch: "Nenhum fluxo encontrado",
        emptyTitleNoFlows: "Nenhum fluxo criado ainda",
        emptyDescSearch: "Tente usar outros termos de pesquisa",
        emptyDescNoFlows: "Crie seu primeiro fluxo de conversa para automatizar atendimentos",
        createFirstFlow: "Criar Primeiro Fluxo",
        createFlowAriaLabel: "Criar fluxo",
        menu: {
          export: "Exportar (.zip)",
          open: "Abrir fluxo",
          edit: "Editar fluxo",
          delete: "Excluir fluxo",
        },
        deleteTitle: 'Excluir fluxo "{{name}}"?',
        deleteBody: "Esta ação não pode ser desfeita. Todas as integrações relacionadas serão perdidas.",
        duplicateTitle: 'Duplicar fluxo "{{name}}"?',
        duplicateBody: "Uma cópia do fluxo será criada para você editar.",
        toast: {
          activated: "ativado",
          deactivated: "desativado",
          toggled: "Fluxo {{status}} com sucesso",
          deleted: "Fluxo excluído com sucesso",
          duplicated: "Fluxo duplicado com sucesso",
          invalidZip: "Por favor, selecione um arquivo ZIP (.zip)",
          imported: "Fluxo importado com sucesso",
        },
      },
      floup: {
        page: {
          title: "Follow UP - Templates de Fluxo",
          newTemplate: "Novo Template",
          editTemplate: "Editar Template",
          steps: "{{count}} passos",
          active: "Ativo",
          inactive: "Inativo",
          tooltips: { edit: "Editar", duplicate: "Duplicar", delete: "Deletar" },
          saveError: "Erro ao salvar o Follow UP. Verifique o console para mais detalhes.",
          deleteError: "Erro ao deletar o Follow UP. Verifique o console para mais detalhes.",
          uploadError: "Erro no upload do arquivo. Verifique o console para mais detalhes.",
          defaultName: "este floup",
          templateTypes: {
            client: { title: "Template para Clientes", description: "Fluxo automatizado para clientes existentes", defaultMessage: "Olá! Como podemos ajudá-lo hoje?" },
            lead: { title: "Template para Leads", description: "Fluxo de nutrição para novos leads", defaultMessage: "Olá! Bem-vindo! Temos uma oferta especial para você." },
            custom: { title: "Template Personalizado", description: "Crie seu próprio fluxo com condições específicas" },
          },
          basicInfo: "Informações Básicas",
          templateName: "Nome do Template",
          templateTypeLabel: "Tipo do Template",
          templateTypeOptions: { client: "Cliente", lead: "Lead", custom: "Personalizado" },
          description: "Descrição",
          triggerCondition: "Condição para Acionamento",
          triggerConditionHelp: "Defina quando este Follow UP deve ser ativado. Uma vez ativado, todos os passos serão executados sequencialmente, até que as condições de parada sejam atendidas.",
          condition: "Condição",
          conditionOptions: { queue: "Fila do sistema", tag: "Tag do sistema", firstClientInteraction: "Primeira interação do cliente", firstAttendantInteraction: "Primeira interação do atendente" },
          queue: "Fila",
          selectQueue: "Selecionar fila",
          tag: "Tag",
          selectTag: "Selecionar tag",
          conditionDescription: "Descrição da condição",
          conditionDescriptionPlaceholder: "Ex: Cliente enviou primeira mensagem",
          stopControls: "Controles de Parada do Fluxo",
          stopConditions: {
            anyMessage: "1. Caso o Contato responder qualquer mensagem",
            keyword: "2. Caso o Contato responder uma Palavra chave",
            keywordLabel: "Palavra chave",
            keywordPlaceholder: "Ex: PARAR, CANCELAR, SAIR",
            ticketClosed: "3. Caso o Ticket for Fechado",
          },
          stepsHeading: "Passos do Fluxo",
          addStep: "Adicionar Passo",
          cancel: "Cancelar",
          saveTemplate: "Salvar Template",
          step: {
            title: "Passo {{order}}",
            emptyMessage: "Mensagem vazia",
            attachment: "Anexo",
            message: "Mensagem",
            charsCount: "{{count}}/500 caracteres",
            value: "Valor",
            timeUnit: "Unidade de Tempo",
            timeUnits: { minutes: "Minutos", hours: "Horas", days: "Dias", weeks: "Semanas", months: "Meses", years: "Anos" },
            sendAfter: "Enviar após {{value}} {{unit}}",
            attachmentLink: "Anexo/Link",
            linkOption: "Link",
            uploadOption: "Upload",
            pasteUrl: "Cole a URL aqui",
            removeLink: "Remover link",
            removeMedia: "Remover mídia",
            chooseFile: "Escolher Arquivo",
            uploading: "Enviando {{fileName}}...",
            videoPlayerTitle: "Player de Vídeo",
            videoNotSupported: "Seu navegador não suporta o elemento de vídeo.",
            removeStep: "Remover Passo",
          },
          preview: {
            title: "Preview da Mensagem",
            attachment: "Anexo",
            hint: "Ícone de anexo aparecerá aqui",
          },
          deleteDialog: {
            title: "Confirmar Exclusão",
            body: 'Tem certeza que deseja deletar o Follow UP "{{name}}"? Esta ação não pode ser desfeita e todas as mídias associadas serão excluídas permanentemente.',
            cancel: "Cancelar",
            confirm: "Deletar",
          },
        },
        selector: {
          stopSuccess: "Follow UP interrompido com sucesso",
          stopButton: "Parar Follow UP",
          nextSteps: "Próximos passos:",
          active: "Ativo",
          selectLabel: "Selecionar Follow UP",
          chooseTemplate: "Escolher template...",
          infoTooltip: "Informações sobre Follow UP",
          stageLabel: "{{name}} - Etapa {{current}} de {{total}}",
          nextRun: "Próxima execução: {{date}}",
          activeShort: "Follow UP ativo",
          noneActive: "Nenhum Follow UP ativo",
          noneActiveHelper: "Este contato não está em nenhum Follow UP no momento",
          infoDialog: {
            title: "Sobre o Sistema Follow UP",
            body1: "O <strong>Follow UP</strong> permite criar fluxos de mensagens e atribuí-los a um contato ou ticket para execução automática.",
            body2: "Selecione um template ativo para iniciar. Você pode interromper a qualquer momento.",
            close: "Entendi",
          },
        },
        dashboard: {
          title: "Dashboard de Follow UP por Etapas",
          refresh: "Atualizar",
          error: "Erro",
          next: "Próxima: {{date}}",
          recentError: "⚠️ Erro recente",
          stage: "Etapa {{order}}",
          noMessage: "Sem mensagem",
          noContactsInStage: "Nenhum contato nesta etapa",
          selectLabel: "Follow UP",
          inactive: "(Inativo)",
          stagesCount: "Etapas",
          contactsCount: "Contatos",
          search: "Buscar",
          channel: "Canal",
          allChannels: "Todos",
          selectFloup: "Selecione um Floup para visualizar as etapas",
          noData: "Nenhum dado encontrado para este Floup",
          noStages: "Nenhuma etapa encontrada",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      pendingTicketOverlay: {
        title: "Conversa Bloqueada",
        subtitle: "Este ticket está aguardando aceite. Aceite a conversa para visualizar e responder às mensagens do cliente.",
        statusWaiting: "Status: Aguardando",
        defaultContactName: "Contato",
        accepting: "Aceitando...",
        acceptConversation: "Aceitar Conversa",
        warning: "🚫 Você não pode visualizar as mensagens antes de aceitar o ticket",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        hideFilters: "Ocultar Filtros",
        showFilters: "Mostrar Filtros",
        satisfactionSurvey: "Pesquisa de satisfação",
        attendances: "Atendimentos",
        errorFetchingTickets: "Erro ao buscar informações dos tickets",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
          receiveComments: "Receber Comentários",
        },
        receiveComments: {
          enabled: "Recebimento de comentários habilitado",
          disabled: "Recebimento de comentários desabilitado",
          tooltip: {
            enabled: "Comentários estão sendo recebidos. Clique para desabilitar.",
            disabled: "Comentários não estão sendo recebidos. Clique para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
        buttons: {
          close: "Fechar",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        tabs: {
          general: "Geral",
          aiModel: "IA & Modelo",
          messages: "Mensagens",
          voice: "Voz",
        },
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          provider: "Provedor",
          model: "Modelo",
          modelRecommended: "(Recomendado)",
          modelEconomic: "(Econômico)",
          trainingLabel: "Treinamento / Prompt do Sistema",
          trainingPlaceholder: "Ex: Você é um assistente virtual da empresa X. Seu papel é atender clientes, tirar dúvidas sobre produtos e serviços...",
          temperatureHelper: "0 = preciso, 1 = criativo",
          maxTokensHelper: "Tamanho máx. da resposta",
          maxMessagesHelper: "Contexto de memória",
          greetingMessage: "Mensagem de Saudação Inicial",
          greetingPlaceholder: "Ex: Olá {{firstName}}! 👋 Sou o assistente virtual da empresa. Como posso te ajudar?",
          greetingHelper: "Primeira mensagem enviada ao cliente quando a IA assumir. Deixe vazio para a IA iniciar diretamente.",
          transferMessage: "Mensagem de Transferência",
          transferPlaceholder: "Ex: Entendido! Vou te transferir para um atendente humano. Aguarde um momento! 😊",
          transferHelper: "Mensagem enviada quando o cliente solicitar falar com um atendente.",
          errorMessage: "Mensagem de Erro",
          errorPlaceholder: "Ex: Desculpe, estou com dificuldades técnicas no momento. Tente novamente mais tarde.",
          errorHelper: "Mensagem enviada quando ocorrer erro na IA.",
          transferKeywordsTitle: "🔑 Palavras-chave de Transferência",
          transferKeywords: "Palavras-chave de Transferência",
          transferKeywordsPlaceholder: "Ex: falar com humano, quero atendente, sair da ia, me ajuda de verdade",
          transferKeywordsHelper: "Palavras ou frases separadas por vírgula. Quando o cliente digitar alguma delas, será transferido para um atendente. As palavras padrão do sistema continuam ativas.",
          voiceMode: "Modo de Resposta",
          voiceText: "Texto",
          voiceKeyAzure: "Chave de Voz (Azure)",
          voiceRegionAzure: "Região de Voz (Azure)",
          voiceOnlyOpenAiWarning: "⚠️ A resposta por voz funciona apenas com o provedor OpenAI. Com Gemini, a resposta será sempre em texto.",
        },
        variables: {
          availableInPrompt: "💡 Variáveis disponíveis no prompt:",
          availableInMessages: "💡 Variáveis disponíveis nas mensagens:",
          contactName: "Nome do contato",
          firstName: "Primeiro nome",
          queueName: "Nome da fila",
          agentName: "Nome do atendente",
          currentDate: "Data atual",
          currentHour: "Hora atual",
          greeting: "Saudação (Bom dia...)",
        },
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          promptRequired: "Descreva o treinamento para Inteligência Artificial",
          voiceRequired: "Informe o modo para Voz",
          maxTokensRequired: "Informe o número máximo de tokens",
          temperatureRequired: "Informe a temperatura",
          apikeyRequired: "Informe a API Key",
          queueRequired: "Informe a fila",
          maxMessagesRequired: "Informe o número máximo de mensagens",
          missingQueue: "Informe o setor",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
        noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showReturnQueueButton: "Mostrar botão de devolver para fila",
          showTransferTicketButton: "Mostrar botão de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver automações",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        unreadFilter: {
          onlyUnread: "Somente não lidos",
          all: "Todos",
        },
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        selectQueue: "Selecione uma fila",
        selectConnection: "Selecione uma Conexão",
        queueRequired: "Selecione uma fila",
        otherUser: "Outro usuário",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          automations: "Automações",
          campaignFlow: "Fluxo de Campanha",
          conversationFlow: "Fluxo de conversa",
          followUpTemplates: "Follow UP (Templates)",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            open: "Aberto",
            pending: "Pendente",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            transferredTicketStatus:
              "Status do ticket ao transferir com usuário",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
            newTicket: "Criar Novo Ticket",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        placeholderPending:
          "Digite sua mensagem interna (ticket aguardando)...",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
        pendingAlert: {
          title: "Ticket Aguardando:",
          description: "Apenas mensagens internas são permitidas neste momento.",
        },
        flowAlert: {
          title: "Fluxo em Execução:",
          description: "Campo de mensagem temporariamente desabilitado.",
        },
        formatMenu: {
          bold: "Negrito",
          italic: "Itálico",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista com Marcadores",
          quote: "Citação",
          clearFormat: "Limpar Formatação",
        },
        ghostMention: {
          tooltip: "Marcação Fantasma (notifica todos sem mostrar @)",
          label: "Marcação Fantasma",
        },
        signature: {
          label: "Assinatura",
        },
        comments: {
          tooltip: "Habilitar/Desabilitar Comentários",
          label: "Comentários",
        },
        quickAnswers: {
          hintNavigate: "{{count}} respostas • use ↑↓ para navegar",
          hintScroll: "{{count}} respostas • role para ver mais",
        },
        errors: {
          ticketIdNotFound: "Erro: ID do ticket não encontrado",
        },
        internalMessageLabel: "Mensagem Interna",
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
        connections: "Conexões",
        newCampaign: "Nova Campanha",
        nameNotDefined: "Nome não definido",
        phrasesConfigured: "{{count}} frase(s) configurada(s)",
        active: "Ativo",
        inactive: "Inativo",
        editCampaignTooltip: "Editar campanha",
        deleteCampaignTooltip: "Excluir campanha",
        noCampaignsFound: "Nenhuma campanha encontrada",
        noCampaignsHelper: 'Clique em "Nova Campanha" para criar sua primeira campanha de fluxo',
        noConnection: "Nenhuma conexão",
        moreConnections: "Mais {{count}} conexão(ões)",
        toast: {
          deleted: "Campanha deletada com sucesso",
          errorLoadingFlows: "Erro ao carregar fluxos",
          errorLoadingConnections: "Erro ao carregar conexões",
          errorLoadingCampaign: "Erro ao carregar dados da campanha",
          flowNotFound: "Fluxo selecionado não encontrado",
          saveError: "Erro ao salvar campanha",
          fillRequiredFields: "Por favor, preencha todos os campos obrigatórios",
          updated: "Campanha atualizada com sucesso!",
          created: "Campanha criada com sucesso!",
        },
        campaignNameLabel: "Nome da campanha",
        selectFlowLabel: "Selecione um fluxo",
        multiple: "(Múltiplas)",
        whatsappConnectionsLabel: "Conexões WhatsApp",
        connectionsSelectedTitle: "{{count}} conexão(ões) selecionada(s):",
        connectionsSelectedDescription: "A campanha será executada quando qualquer uma dessas conexões receber mensagens que façam match com as frases configuradas.",
        filterByTag: "Filtrar por Tag do Contato",
        optional: "(opcional)",
        filterByTagDescription: "Se selecionada(s), o fluxo só será disparado para contatos que possuam pelo menos uma dessas tags no atendimento.",
        tagsOptionalLabel: "Tags (opcional)",
        tagFilterActive: "🏷️ Filtro ativo: O fluxo só disparará para contatos que tenham pelo menos uma das {{count}} tag(s) selecionada(s).",
        keywordsTitle: "Palavras-chave que disparam o fluxo",
        orLogicInfo: "🔀 Lógica OU: O fluxo será disparado se o contato enviar qualquer uma das palavras/frases abaixo.",
        exactPartialInfo: "Exata: mensagem idêntica.  |  Parcial: palavra contida em qualquer parte da mensagem.",
        or: "OU",
        phraseLabel: "Palavra/frase {{index}}",
        phrasePlaceholder: "Ex: oi, olá, quero orçamento...",
        type: "Tipo",
        exact: "Exata",
        partial: "Parcial",
        addPhraseButton: "+ Adicionar outra palavra/frase (OU)",
        saving: "Salvando...",
        validation: {
          nameRequired: "Nome é obrigatório",
          flowRequired: "Fluxo é obrigatório",
          connectionRequired: "Pelo menos uma conexão deve ser selecionada",
          fieldRequired: "Campo obrigatório",
        },
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
        pwaName: "Nome do PWA",
        pwaNameHelper: "Nome exibido ao instalar o app no celular",
        pwaLogo: "Ícone do PWA (192x192 ou maior)",
        pwaLogoHelper: "Ícone exibido na tela inicial do celular",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema",
          pwa: "PWA (App Instalável)",
          pwaDescription: "Configure o nome e ícone para quando o app for instalado no celular"
        }
      },
    },
  },
};

export { messages };
